import React from 'react';
import Dialog from '@mui/material/Dialog';
import {
  AppBar,
  DialogContent,
  IconButton,
  Slide,
  Toolbar,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { TransitionProps } from '@mui/material/transitions';
import { BankAccountStatistics } from '../../../workers/BankAccountStatistics';
import { StatsModalContent } from './StatsModalContent';

export interface StatsModalProps {
  open: boolean;
  statistics: BankAccountStatistics | null;
  onClose: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const StatsModal = (props: StatsModalProps) => {
  const { open, onClose, statistics } = props;
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={true}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton
            edge={'start'}
            aria-label={'close'}
            color={'inherit'}
            onClick={onClose}
            size="large"
          >
            <Close />
          </IconButton>
          <Typography
            sx={{ margin: (theme) => theme.spacing(0, 2) }}
            variant="h6"
          >
            Statistiques
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent
        sx={{
          marginTop: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
        }}
      >
        {statistics && statistics.months.length > 0 ? (
          <StatsModalContent statistics={statistics} />
        ) : null}
      </DialogContent>
    </Dialog>
  );
};
